
import { apiConstants } from "../../shared/config";
import work from "./type";
const code = apiConstants.code;
const baseRouteName = `${code}.${work.key}_`;

export const type = work.key;
export const routes = {
    path: `/${code}/${work.basePath}`,
    component: () => import ( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/MunicipalInterventionsBase.vue'),
    children: [
        {
            path: `home`,
            name: `${code}.${work.basePath}.home`,
            component: () => import ( /* webpackChunkName: "gimgestao" */ './views/Home.vue'),
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'municipal_interventions_home.title',
            }
        },
        {
            path: `status`,
            component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/status/StatusBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}statuses`,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/status/StatusList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_statuses.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}statuses.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/status/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_statuses.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}statuses.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/status/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_statuses.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'municipal_interventions_statuses.title',
            }
        },
        {
            path: `type`,
            component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/type/TypeBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}types`,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/type/TypeList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_types.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}types.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/type/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_types.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}types.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/type/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_types.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'municipal_interventions_types.title',
            }
        },
        {
            path: `service_typology`,
            component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/serviceTypology/ServiceTypologyBase.vue'),
            children: [
               {
                    path: '/',
                    name: `${baseRouteName}service_typologies`,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/serviceTypology/ServiceTypologyList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_service_typologies.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}service_typologies.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/serviceTypology/ServiceTypologyDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_service_typologies.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}service_typologies.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/serviceTypology/ServiceTypologyDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_service_typologies.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'municipal_interventions_service_typologies.title',
            }
        },
        {
            path: `unity`,
            component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/unity/UnityBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}unities`,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/unity/UnityList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_unities.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}unities.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/unity/UnityDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_unities.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}unities.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/unity/UnityDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'municipal_interventions_unities.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'municipal_interventions_unities.title',
            }
        },
        {
            path: `report`,
            component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/report/ReportBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}reports`,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/report/ReportList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_reports.titles',
                    }
                },
                {
                    path: 'config',
                    name: `${baseRouteName}reports.config`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/report/ReportConfig.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_reports.title',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}reports.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/report/ReportDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_reports.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}reports.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_interventions" */ './views/report/ReportDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_reports.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'parish_interventions_reports.titles',
            }
        },
        {
            path: `global_type`,
            component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}global_types`,
                    component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_types.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}global_types.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_types.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}global_types.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_types.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'global_types.titles',
            }
        },
        {
            path: `global_status`,
            component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}global_statuses`,
                    component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_statuses.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}global_statuses.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_statuses.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}global_statuses.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_statuses.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'global_statuses.titles',
            }
        },
    ],
    meta: {
        auth: undefined,
        hideHeaderName: true,
        title: 'municipal_interventions_home.title',
    }
};

export default routes;